<template>
  <div class="CommonReviewsCollect">
    <div class="rt-crm-CommonReviewsBtn" @click="setCommonReviews">
      <img
        class="rt-crm-Icon"
        src="https://cdn2.fscloud.com.cn/$web/cdn2/saascrm/assets/imgs/new_collect.png"
      />
      <!-- 收藏本条    -->
      <span>{{ $_t('收藏本条', 'approval.collection') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    actionType: Number,
    content: String
  },
  data: function () {
    return {};
  },
  computed: {},
  watch: {},
  mounted: function () {},
  methods: {
    setCommonReviews: function () {
      var that = this;
      var obj = {
        new_iscommon: false,
        new_type: that.actionType,
        new_content: that.content
      };

      if (!obj.new_content) {
        // "请填写评语内容!"
        rt.showErrorToast(
          this.$_t('approval.enterreviews', '请填写评语内容！')
        );
        return;
      }
      rt.post('api/CrmFlow/SetCommonReviews', obj)
        .then((res) => {
          if (res) {
            // "收藏成功！"
            rt.showSuccessToast(
              this.$_t('approval.collectionsuccess', '收藏成功')
            );
          }
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// CommonReviewsCollect.vue?1d71da06